<forge-card [ngClass]="{'full-width': fullWidth }">
    <h2>{{headerText}}</h2>
    <ng-content></ng-content>
</forge-card>